import React from 'react';
import CDNImage from "../../common/cdn-image";

import '../../../styles/shop/print-long-info.scss';

const PrintDetailsInfo = () => {
	return (
		<div className="print-long-info-container">
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/locally-produced.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Locally produced
					</p>
					<p className="body">
						Partnerships with a selection of print studios around the world mean orders for US, UK, EU, Canada
						and Australia are locally produced and don’t have far to travel.
					</p>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/printing.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Printing
					</p>
					<p className="body">
						Printed using pigment-based archival inks (Giclée process) on high grade heavyweight art paper:
						100% cotton, finely textured, and acid-free archival substrates purposefully chosen for optimal
						historical art reproduction.
					</p>
					<ul>
						<li>US and Canada: Epson Somerset Velvet (255gsm)</li>
						<li>Australia: Hahnemühle’s Photo Rag (188gsm)</li>
						<li>EU: Hahnemühle’s Photo Rag (310gsm)</li>
						<li>UK and rest of world: St Cuthbert Mill’s Somerset Enhanced Velvet (255gsm).</li>
					</ul>
				</div>
			</div>
			<div className="detail-block">
				<div className="icon">
					<CDNImage
						imagePath="/interface/framing.png"
						width="128"
						height="128"
					/>
				</div>
				<div className="text">
					<p className="headline">
						Framing
					</p>
					<p className="body">
						All frames are custom produced to order, hand-made with high quality, acid-free archival materials
						to create a beautiful piece that will last for generations.
					</p>
					<ul>
						<li>Solid wood with a 3/4" face (and 1" depth for US orders, 3/4" elsewhere)</li>
						<li>2" acid-free 4-ply natural white mat with bevelled edges</li>
						<li>Shatterproof, high quality UV-shielding acrylic glazing</li>
						<li>Archival acid-free foam core backing</li>
						<li>Ready to hang with included fixtures</li>
					</ul>
					<p className="body">
						Why acrylic instead of glass? Although more expensive than glass, like most art-sellers and galleries
						we’ve chosen acrylic glazing for its superior UV protection and its robustness in transport.
					</p>
				</div>
			</div>
		</div>
	)
};

export default PrintDetailsInfo;